import Color from 'color';
import styled from 'styled-components';

const negateActive = '#b42318';
const chipAddedBg = '#4a6741';

export const Bar = styled.div<{
  $breakpoint: string,
  $minBreakpoint?: string,
  $aboveHeader?: boolean,
}>`
  display: none;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 14px 6px;
  background: white;
  border-bottom: 1px solid ${Color('lightgrey').lighten(0.05).toString()};
  position: ${({ $aboveHeader }) => ($aboveHeader ? 'relative' : 'sticky')};
  top: 0;
  z-index: ${({ $aboveHeader }) => ($aboveHeader ? 11 : 16)};

  ${({ $breakpoint, $minBreakpoint }) => {
    if ($minBreakpoint) {
      return `
        @media (max-width: ${$breakpoint}) and (min-width: ${$minBreakpoint}) {
          display: block;
        }
      `;
    }
    return `
      @media (max-width: ${$breakpoint}) {
        display: block;
      }
    `;
  }}
`;

export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  width: 100%;
`;

export const Chip = styled.button<{ $negate?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  max-width: 100%;
  min-height: 26px;
  padding: 3px 6px 3px 8px;
  border: none;
  border-radius: 3px;
  background: ${({ $negate }) => (
    $negate
      ? Color(negateActive).lighten(0.05).toString()
      : chipAddedBg
  )};
  color: white;
  cursor: pointer;
  font: inherit;
`;

export const ChipIcon = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  opacity: 0.9;

  & > svg {
    font-size: 13px;
  }
`;

export const ChipText = styled.span`
  flex: 1;
  min-width: 0;
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
`;

export const ChipRemove = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
  color: white;
  cursor: pointer;
  padding: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.28);
  }

  & > svg {
    font-size: 13px;
  }
`;
